import React from 'react'
import styled from 'styled-components'

import { breakpoints } from "../styles"
import Hero from './Hero'
import { FrontEnd, Center } from './Title'
import TopRight from './TopRight'

const Title = styled.h1`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  text-align: center;
`

const Big = styled(FrontEnd)`
  transform: translate3d(0,0,0);
  font-size: 3.5rem;
  ${props => props.fadeIn && `animation: fade-in 0.6s ${props.theme.animating ? '2s' : '0s'} ease-out both;`}
  ${breakpoints.phone`
    font-size: 2.5rem;
  `}
`

const Small = styled(Center)`
  font-size: 2.25rem;
  ${props => props.fadeIn && `animation: fade-in 0.6s ${props.theme.animating ? '2.3s' : '0s'} ease-out both;`}
  ${breakpoints.phone`
    font-size: 1.75rem;
  `}
`

const MainTitle = styled.span`
  display: flex;
  flex-direction: column;
  > *+* {
    margin-top: 1rem;
  }
`

export default ({fadeIn = true, minSize, bottomBuffer}) => (
  <Hero fadeIn={fadeIn} minSize={minSize} bottomBuffer={bottomBuffer}>
    <Title>
      <MainTitle>
        <Big fadeIn={fadeIn}/>
        <Small fadeIn={fadeIn}/>
      </MainTitle>
    </Title>
    <TopRight homepage/>
  </Hero>
)



/** WEBPACK FOOTER **
 ** ./src/components/HomepageHero.js
 **/